import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import WSChat from 'components/chat/WSChat';
import Popup from 'components/common/Popup/Popup';
import SnackBar from 'components/common/SnackBar/SnackBar';
import AuthPromoBanner from 'components/utils/AuthPromoBanner';

import PromoSpinner from './PromoSpinner/PromoSpinner';
import { useApp } from '../../../hooks/selectors';
import MessageBodyService from '../../utils/MessageBodyService';
import PromoModalWithTimer from '../utils/PromoModalWithTimer';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    pointer-events: ${(props) => (props.isShowSpinner ? 'none' : null)};
    opacity: ${(props) => (props.isShowSpinner ? '0.3' : null)};

    & > form {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    & > div {
        filter: ${(props) => (props.isShowSpinner ? 'blur(2px)' : null)};
    }
`;

const BaseLayoutPromo = ({ children, dataTestId, showPromoBanner = false, loading = false, isShowSpinner = false }) => {
    const { modalComponent, isShowModal, isShowModalWithTimer } = useApp();
    return (
        <>
            {showPromoBanner && <AuthPromoBanner />}
            <Wrapper data-testid={dataTestId} isShowSpinner={isShowSpinner}>
                {!loading ? children : null}
                {isShowModal && modalComponent}
                {isShowModalWithTimer && <PromoModalWithTimer />}
                <SnackBar />
                <Popup />
                <MessageBodyService />
                <PromoSpinner />
                <WSChat />
            </Wrapper>
        </>
    );
};
BaseLayoutPromo.propTypes = {
    showPromoBanner: PropTypes.bool,
    loading: PropTypes.bool,
    isShowSpinner: PropTypes.bool,
    dataTestId: PropTypes.string,
};

export default BaseLayoutPromo;
